/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */

import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Chat Flyout Component
 * 
 * Provides a resizable, collapsible flyout panel for chat interface.
 * Features:
 * - Configurable width/height as percentage of screen
 * - Vertical resize with drag handle
 * - Split view with optional right panel for chat history
 * - Left or right screen positioning
 * - Persistent footer option
 * 
 * @example
 * <app-chat-flyout 
 *   [(isOpen)]="showChat"
 *   [headerText]="'Chat with EVA'"
 *   [flyoutWidthPercent]="40"
 *   (onRightPanelToggle)="handlePanelToggle($event)">
 *   <div leftPanel>Main chat content</div>
 *   <div rightPanel>Chat history</div>
 * </app-chat-flyout>
 */
@Component({
    selector: 'app-chat-flyout',
    templateUrl: './chat-flyout.component.html',
    styleUrls: ['./chat-flyout.component.scss'],
    standalone: false
})
export class ChatFlyoutComponent implements OnInit, OnChanges {
    /** Controls flyout visibility (two-way binding) */
    @Input() isOpen = false;

    /** Header text to display at top of flyout */
    @Input() headerText = '';

    /** Flyout width as percentage of screen width (20-100) */
    @Input() flyoutWidthPercent = 40;

    /** Optional flyout height as percentage of screen height */
    @Input() flyoutHeightPercent?: number;

    /** Position of flyout: 'left' or 'right' side of screen */
    @Input() flyoutPosition: 'left' | 'right' = 'right';

    /** Whether footer should stick to bottom */
    @Input() pinFooterToBottom = true;

    /** Whether footer stays visible when flyout is closed */
    @Input() keepFooterVisibleWhenClosed = true;

    /** Emits when flyout open/closed state changes */
    @Output() isOpenChange = new EventEmitter<boolean>();

    /** Emits when right panel is toggled */
    @Output() onRightPanelToggle = new EventEmitter<boolean>();

    /** Indicates if flyout is fully closed for animations */
    public isFullyClosed = false;

    /** Reference to flyout container element */
    @ViewChild('flyout') flyoutElement!: ElementRef;

    /** Reference to resize handle element */
    @ViewChild('resizeHandle') resizeHandle!: ElementRef;

    /** Initial height before resize drag */
    private initialHeight = 0;

    /** Indicates if user is currently dragging resize handle */
    private isDragging = false;

    /** Screen height in pixels */
    private screenHeight = 0;

    /** Minimum flyout height as percentage */
    private minHeight = 30;

    /** Maximum flyout height as percentage */
    private maxHeight = 100;

    /** Current flyout height as percentage */
    public currentHeight = 100;

    /** Controls visibility of right panel (chat history) */
    public showRightPanel = false;

    /** Left panel width as percentage of flyout width */
    public leftPanelWidth = 100;

    /** Right panel width as percentage of flyout width */
    public rightPanelWidth = 0;

    /** Height threshold (%) for enabling split view */
    public splitThreshold = 50;

    /** Tracks if right panel was manually toggled by user */
    private isRightPanelManuallyToggled = false;

    get resolvedFlyoutWidth(): number {
        const minWidth = 20;
        const maxWidth = 100;
        const parsedWidth = Number(this.flyoutWidthPercent);

        if (Number.isNaN(parsedWidth)) {
            return 40;
        }

        return Math.min(maxWidth, Math.max(minWidth, parsedWidth));
    }

    /**
     * Get resolved flyout height with bounds checking
     * @returns Validated height percentage or default 100%
     */
    get resolvedFlyoutHeight(): number {
        const defaultHeight = 100;
        const parsedHeight = Number(this.flyoutHeightPercent);

        if (Number.isNaN(parsedHeight)) {
            return defaultHeight;
        }

        return Math.min(this.maxHeight, Math.max(this.minHeight, parsedHeight));
    }

    /**
     * Check if flyout is positioned on the left side
     * @returns True if left-positioned
     */
    get isLeftPosition(): boolean {
        return this.flyoutPosition === 'left';
    }

    /**
     * Check if footer should be pinned to bottom
     * @returns True if footer should pin
     */
    get shouldPinFooter(): boolean {
        return this.pinFooterToBottom || this.keepFooterVisibleWhenClosed;
    }

    constructor(private elementRef: ElementRef, public translate: TranslateService) { }

    /**
     * Initialize component
     * Sets up initial dimensions and panel sizes
     */
    ngOnInit(): void {
        this.currentHeight = this.resolvedFlyoutHeight;
        this.updateScreenHeight();
        this.updatePanelSizes();
        this.closeFlyout();
    }

    /**
     * Handle input property changes
     * @param changes - Changed properties
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['isOpen']?.currentValue === true) {
            this.isFullyClosed = false;
        }

        if (changes['flyoutHeightPercent']) {
            this.currentHeight = this.resolvedFlyoutHeight;
            this.updatePanelSizes();
        }
    }

    /**
     * Handle window resize events
     * @param event - Resize event
     */
    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        this.updateScreenHeight();
        this.updatePanelSizes();
    }

    /**
     * Update screen height tracking
     * @private
     */
    private updateScreenHeight(): void {
        this.screenHeight = window.innerHeight;
    }

    /**
     * Updates the panel sizes based on the current flyout height
     * - If flyout height > splitThreshold, show both panels (60/40 split)
     * - Otherwise, show only left panel (100% width)
     */
    private updatePanelSizes(): void {
        const shouldShowRightPanel = this.currentHeight > this.splitThreshold;

        // Only auto-close the right panel on resize; never auto-open it.
        if (!shouldShowRightPanel && this.showRightPanel && !this.isRightPanelManuallyToggled) {
            this.showRightPanel = false;
            this.leftPanelWidth = 100;
            this.rightPanelWidth = 0;
        }
    }

    /**
     * Toggle right panel visibility manually
     * Adjusts panel widths and flyout height as needed
     */
    toggleRightPanel(): void {
        this.isRightPanelManuallyToggled = true;
        this.showRightPanel = !this.showRightPanel;

        if (this.showRightPanel) {
            this.leftPanelWidth = this.currentHeight < this.splitThreshold ? 0 : 70;
            this.rightPanelWidth = this.currentHeight < this.splitThreshold ? 100 : 30;

            // If flyout is too short, increase it to accommodate both panels
            if (this.currentHeight < this.splitThreshold) {
                this.currentHeight = this.splitThreshold + 5; // Add 5% to be safe
            }
        } else {
            this.leftPanelWidth = 100;
            this.rightPanelWidth = 0;
        }

        // Reset the manual toggle flag after a delay
        setTimeout(() => {
            this.isRightPanelManuallyToggled = false;
            this.onRightPanelToggle.emit(this.showRightPanel);
        }, 500);
    }

    /**
     * Toggle flyout open/closed state
     */
    toggleFlyout(): void {
        this.isOpen = !this.isOpen;
        this.isOpenChange.emit(this.isOpen);

        if (this.isOpen) {
            this.isFullyClosed = false;
            this.resetFlyoutState();
        }
    }

    /**
     * Open the flyout panel
     */
    openFlyout(): void {
        if (this.isOpen) {
            return;
        }

        this.isOpen = true;
        this.isOpenChange.emit(this.isOpen);
        this.isFullyClosed = false;
        this.resetFlyoutState();
    }

    /**
     * Start resizing flyout height
     * Attaches mouse move listeners for drag operation
     * 
     * @param event - Mouse down event on resize handle
     */
    startResize(event: MouseEvent): void {
        event.preventDefault();
        this.isDragging = true;
        this.initialHeight = this.flyoutElement.nativeElement.offsetHeight;

        // Add mousemove and mouseup event listeners
        document.addEventListener('mousemove', this.resizeMouseMove);
        document.addEventListener('mouseup', this.resizeMouseUp);
    }

    /**
     * Handle mouse move during resize operation
     * @param event - Mouse move event
     */
    @HostListener('document:mousemove', ['$event'])
    resizeMouseMove = (event: MouseEvent) => {
        if (this.isDragging) {
            const newHeight = 100 - ((event.clientY / this.screenHeight) * 100);

            // Ensure height is within constraints
            if (newHeight >= this.minHeight && newHeight <= this.maxHeight) {
                this.currentHeight = newHeight;
                this.updatePanelSizes();
            }
        }
    }

    /**
     * Handle mouse up to end resize operation
     * Cleans up event listeners
     */
    @HostListener('document:mouseup')
    resizeMouseUp = () => {
        this.isDragging = false;

        // Remove event listeners
        document.removeEventListener('mousemove', this.resizeMouseMove);
        document.removeEventListener('mouseup', this.resizeMouseUp);
    }

    /**
     * Close the flyout panel
     * Resets panel states
     */
    closeFlyout(): void {
        this.isOpen = false;
        this.isOpenChange.emit(this.isOpen);
        this.isFullyClosed = true;
        // Reset panel states
        this.showRightPanel = false;
        this.leftPanelWidth = 100;
        this.rightPanelWidth = 0;
        this.isRightPanelManuallyToggled = false;
    }

    /**
     * Reset flyout to initial state
     * @private
     */
    private resetFlyoutState(): void {
        this.currentHeight = this.resolvedFlyoutHeight;
        this.showRightPanel = false;
        this.leftPanelWidth = 100;
        this.rightPanelWidth = 0;
        this.isRightPanelManuallyToggled = false;
    }
}